/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAidAliasRequest
 */
export interface UpdateAidAliasRequest {
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof UpdateAidAliasRequest
     */
    alias: string;
}

/**
 * Check if a given object implements the UpdateAidAliasRequest interface.
 */
export function instanceOfUpdateAidAliasRequest(value: object): boolean {
    if (!('alias' in value)) return false;
    return true;
}

export function UpdateAidAliasRequestFromJSON(json: any): UpdateAidAliasRequest {
    return UpdateAidAliasRequestFromJSONTyped(json, false);
}

export function UpdateAidAliasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAidAliasRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'alias': json['alias'],
    };
}

export function UpdateAidAliasRequestToJSON(value?: UpdateAidAliasRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alias': value['alias'],
    };
}

